import $ from "jquery";
import Swup from "swup";

export function setup_transitions() {
    const domain = window.location.origin;

    let options = {
        elements: ["#swup"],
        scroll: false,
        debugMode: false
    };

    const swup = new Swup(options);

    document.addEventListener("swup:animationInStart", event => {

        $('body').addClass('page-ready');

        $("html,body").animate(
        {
            scrollTop: 0
        },
            500
        );
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/swup.js